import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import modal from '../styles/modal.module.css';
import styles from '../styles/customeReminder.module.css';
import StateContext from '../context/state/StateContext';

const CustomReminder = ({ close, token }) => {

    const [repeatInterval, setRepeatInterval] = useState(1);
    const [repeatUnit, setRepeatUnit] = useState('week');
    const [selectedDays, setSelectedDays] = useState(new Set(['mon']));
    const [endOption, setEndOption] = useState('never');
    const [endDate, setEndDate] = useState(new Date().toISOString().substr(0, 10)); // Setting 
    const [customOption, setCustomOption] = useState('occurence')
    const [occurrences, setOccurrences] = useState(13);
    const [monthlyRepeat, setMonthlyRepeat] = useState("0")
    const { reminderData, setReminderData } = useContext(StateContext);

    useEffect(() => {
        if (reminderData) {
            if (reminderData && reminderData.repeatInterval) { setRepeatInterval(reminderData.repeatInterval) }
            if (reminderData && reminderData.selectedDays) { setSelectedDays(new Set(reminderData.selectedDays)) }
            if (reminderData && reminderData.repeatUnit) { setRepeatUnit(reminderData.repeatUnit) }
            if (reminderData && reminderData.endDate) { setEndDate(reminderData.endDate) }
            if (reminderData && reminderData.occurrences) { setOccurrences(reminderData.occurrences) }
            if (reminderData && reminderData.endOption) { setEndOption(reminderData.endOption) }
            if(reminderData && reminderData.occurenceOption) { setCustomOption(reminderData.occurenceOption)}
            if(reminderData && reminderData.occurenceDates) {
                 setSelectedDates(reminderData.occurenceDates)}
        }
    }, [])

    const daysOfWeek = [
        { name: 'S', id: 'sun' },
        { name: 'M', id: 'mon' },
        { name: 'T', id: 'tue' },
        { name: 'W', id: 'wed' },
        { name: 'T', id: 'thu' },
        { name: 'F', id: 'fri' },
        { name: 'S', id: 'sat' }
    ];
    const toggleDay = (id) => {
        setSelectedDays(prevDays => {
            const newDays = new Set(prevDays);
            if (newDays.has(id)) {
                if (newDays.size === 1) {
                    console.log("Cannot remove the last selected day");
                    return newDays; // Don't modify the set if it's the last day
                }
                newDays.delete(id);
            } else {
                newDays.add(id);
            }
            return newDays;
        });
    };


    const handleEndOptionChange = (option) => {
        setEndOption(option);
    };

    const handleSubmit = (e) => {
        close({ component: '', open: false })
        if (!e.target.checkValidity()) {
            toast.error("Please select the occurence options")
        }
        e.preventDefault();
        // Store data in Context
        setReminderData({
            repeatInterval,
            repeatUnit,
            selectedDays: Array.from(selectedDays), // Convert Set to Array
            endOption,
            endDate,
            occurrences,
            monthlyRepeat,
            repeated: 0,
            occurenceOption:customOption,
            occurenceDates:selectedDates
        });
    }

    const handleCustomOption = (value) => {
        setCustomOption(value)
        console.log("value is ", value);
    }

    // Note : not in working state but still here for future use
    const getNthWeekday = (date) => {
        const dayOfWeek = date.getDay(); // Sunday is 0, Monday is 1, etc.
        const dayOfMonth = date.getDate();

        // Calculate how many times this day has occurred so far in the month
        const nthOccurrence = Math.ceil(dayOfMonth / 7);

        // Array to map weekday numbers to names
        const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        return `${nthOccurrence} ${weekdays[dayOfWeek]}`; // e.g., "2nd Monday"
    };

    const [selectedDates, setSelectedDates] = useState([]);

    const handleDateChange = (event) => {
        const newDate = event.target.value;
        let date = new Date(newDate);
        if(date.getDay() === 0){
            toast.error("Sundays are not allowed please select another day.")
            return
        }
        // Check if the date is already selected, and add/remove it accordingly
        if (selectedDates.includes(newDate)) {
            setSelectedDates(selectedDates.filter(date => date !== newDate)); // Remove date
        } else if (selectedDates.length < 10) {
            setSelectedDates([...selectedDates, newDate]); // Add date
        }
    };

    const handleRemoveDate = (date) => {
        setSelectedDates(selectedDates.filter(d => d !== date)); // Remove specific date
    };

    // Get today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split('T')[0];

    return (
        <>
            <div className={modal.head}>
                <h3>Custom Recurrence</h3>
                <i className={`bx bx-x ${modal.close}`} onClick={() => { close({ component: '', open: false }) }}></i>
            </div>
            <form onSubmit={handleSubmit}>
                <div className={modal.small_container}>
                    <div className={`${styles.end_options} d-flex align-items-center`}>
                        <div className="checkbox-wrapper-4">
                            <input
                                type="radio"
                                id="occurence"
                                className="inp-cbx"
                                name="customOption"
                                checked={customOption === 'occurence'}
                                onChange={() => handleCustomOption('occurence')}
                            />
                            <label htmlFor="occurence" className="cbx">
                                <span><svg></svg></span>
                                <span className='text'>Custom Options</span>
                            </label>
                        </div>

                        <div className="checkbox-wrapper-4">
                            <input
                                type="radio"
                                id="dates"
                                className="inp-cbx"
                                name="customOption"
                                checked={customOption === 'dates'}
                                onChange={() => handleCustomOption('dates')}
                            />
                            <label htmlFor="dates" className="cbx">
                                <span><svg></svg></span>
                                <span className='text'>Custom Dates</span>
                            </label>
                        </div>
                        </div>

                    {customOption === 'occurence' ? <div className={styles.recurrence_container}>
                        {/* Repeat every section */}
                        <div className={styles.repeat_every}>
                            <label htmlFor="repeat-interval">Repeat every</label>
                            <input
                                type="number"
                                id={styles.repeat_interval}
                                min="1"
                                max="31"
                                value={repeatInterval}
                                onChange={(e) => setRepeatInterval(e.target.value)}
                            />
                            <select
                                id={styles.repeat_unit}
                                value={repeatUnit}
                                onChange={(e) => setRepeatUnit(e.target.value)}
                            >
                                <option value="day">Day</option>
                                <option value="week">Week</option>
                                <option value="month">Month</option>
                            </select>
                        </div>

                        {/* Repeat on section */}
                        {repeatUnit === "week" && <div className={styles.repeat_on}>
                            <label>Repeat on</label>
                            <div className={styles.days}>
                                {daysOfWeek.map(day => (
                                    <button
                                        type='button'
                                        key={day.id}
                                        className={`${styles.day} ${selectedDays.has(day.id) ? styles.active : ''}`}
                                        onClick={() => toggleDay(day.id)}
                                    >
                                        {day.name}
                                    </button>
                                ))}
                            </div>
                        </div>}
                        {/* {repeatUnit === "month" && <div className={styles.recurrence_container}>
                                    <select
                                        id={styles.repeat_unit}
                                        className={styles.repeat_every}
                                        onChange={(e) => {
                                            setMonthlyRepeat(e.target.value)
                                        }}
                                    >
                                        <option value="0">Monthly on Day {(new Date().getDate())}</option>
                                        <option value="1">Monthly on the {getNthWeekday(new Date())}</option>
                                    </select>
                                </div>} */}

                        {/* Ends section */}
                        <div className={styles.ends}>
                            <label>Ends</label>
                            <div className={styles.end_options}>
                                <div className="checkbox-wrapper-4">
                                    <input
                                        type="radio"
                                        id="never"
                                        className="inp-cbx"
                                        name="end"
                                        checked={endOption === 'never'}
                                        onChange={() => handleEndOptionChange('never')}
                                    />
                                    <label htmlFor="never" className="cbx">
                                        <span><svg></svg></span>
                                        <span className='text'>Never</span>
                                    </label>
                                </div>
                                <div className={`checkbox-wrapper-4 ${styles.on}`}>
                                    <input
                                        type="radio"
                                        className="inp-cbx"
                                        id="on-date"
                                        name="end"
                                        checked={endOption === 'on-date'}
                                        onChange={() => handleEndOptionChange('on-date')}
                                    />
                                    <label htmlFor="on-date" className="cbx">
                                        <span><svg></svg></span>
                                        <span className='text'>On</span>
                                    </label>
                                    <input
                                        type="date"
                                        id={styles.end_date}
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                        disabled={endOption !== 'on-date'}
                                    />
                                </div>

                                <div className={`${styles.after} checkbox-wrapper-4`}>
                                    <input
                                        type="radio"
                                        id="after-occurrences"
                                        className="inp-cbx"
                                        name="end"
                                        checked={endOption === 'after-occurrences'}
                                        onChange={() => handleEndOptionChange('after-occurrences')}
                                    />
                                    <label htmlFor="after-occurrences" className="cbx">
                                        <span><svg></svg></span>
                                        <span className='text'>After</span>
                                    </label>
                                    <div className={styles.after_label}>
                                        <input
                                            type="number"
                                            id="occurrences"
                                            min={1}
                                            max={30}
                                            value={occurrences}
                                            onChange={(e) => setOccurrences(e.target.value)}
                                            disabled={endOption !== 'after-occurrences'}
                                        />
                                        <label htmlFor="occurrences">occurrences</label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div> : <>
                        <div className={styles.recurrenceContainer}>
                            <label className={styles.label}>Select Dates (up to 10)</label>

                            <input
                                type="date"
                                className={styles.dateInput}
                                onChange={handleDateChange}
                                disabled={selectedDates.length >= 10} // Disable after 10 dates selected
                                min={today} // Set the minimum date to today
                            />

                            {selectedDates.length > 0 && (
                                <>
                                    <h4 className={styles.selectedDatesTitle}>Selected Dates:</h4>
                                    <ul className={styles.dateList}>
                                        {selectedDates.map((date, index) => (
                                            <li key={index} className={styles.dateItem}>
                                                <span className={styles.dateText}>{date}</span>
                                                <span
                                                    className={styles.removeIcon}
                                                    onClick={() => handleRemoveDate(date)}
                                                >
                                                    &#10006; {/* Cross icon */}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            )}
                            {selectedDates.length === 0 && <p className={styles.noDatesMessage}>No dates selected yet.</p>}
                        </div>
                    </>}
                </div>
                <div className={modal.foot}>
                    <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                        <button type='button' className="button2 cancel" onClick={() => close({ open: false, component: '' })}>Cancel</button>
                        <button type='submit' className={`button2`}>Save</button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default CustomReminder;
